// Implements: F-IDN-027, F-MCK-021
/**
 * `GET /organizations/{org}/people` (mockup v3 P3 and P4): the seats of one organization. It lives
 * in `shared/api` because two modules read it (P3's Personas page and P4's "Personas con acceso"
 * and transfer), and a module may not reach into another.
 */

import type { MemberSummaryView } from "../../types/api";
import { API_BASE } from "./apiBase";
import { httpRequest } from "./httpClient";

export function organizationPeoplePath(organizationId: string): string {
  return `${API_BASE}/organizations/${encodeURIComponent(organizationId)}/people`;
}

export async function fetchOrganizationPeople(
  organizationId: string,
  signal?: AbortSignal,
): Promise<readonly MemberSummaryView[]> {
  const body = await httpRequest<{ readonly people?: readonly MemberSummaryView[] }>(
    organizationPeoplePath(organizationId),
    { signal },
  );
  return body?.people ?? [];
}
